var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { getFocusStyles, Shape, Spacing, withTheming } from '@doordash/design-language';
import styled, { css } from 'styled-components';
var WRAPPER_WIDTH = Spacing.XLarge;
var CONTENT_PADDING = "0 ".concat(Spacing.XxSmall, "px");
export var PageNav = withTheming(styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: ", "px;\n  width: ", "px;\n  padding: ", ";\n  cursor: pointer;\n  background-color: ", ";\n  border: 0;\n  box-shadow: inset 0 0 0 ", "px\n    ", ";\n  border-radius: ", "px;\n  &:focus {\n    ", ";\n    ", ";\n  }\n  &:active {\n    ", "\n  }\n  &:hover {\n    ", "\n  }\n"])), WRAPPER_WIDTH, WRAPPER_WIDTH, CONTENT_PADDING, function (props) {
  return function (_ref) {
    var theme = _ref.theme;
    return props.isDisabled ? theme.Colors.PaginationNumberedNavigationBackgroundDisabled : theme.Colors.PaginationNumberedNavigationBackground;
  };
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.BorderWidth.PaginationNumberedUnselected;
}, function (props) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return props.isDisabled ? theme.Colors.PaginationNumberedNavigationBorderDisabled : theme.Colors.PaginationNumberedNavigationBorder;
  };
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.Shape.PaginationNumbered === Shape.Circle ? WRAPPER_WIDTH : theme.BorderRadius.ButtonDefault;
}, getFocusStyles(), function (props) {
  return props.isDisabled && 'cursor: not-allowed;';
}, function (props) {
  return function (_ref5) {
    var theme = _ref5.theme;
    return props.isDisabled ? 'cursor: not-allowed;' : css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            background-color: ", ";\n            box-shadow: inset 0 0 0 ", "px\n              ", ";\n          "])), theme.Colors.PaginationNumberedNavigationBackgroundPressed, theme.BorderWidth.PaginationNumbered, theme.Colors.PaginationNumberedNavigationBorderPressed);
  };
}, function (props) {
  return function (_ref6) {
    var theme = _ref6.theme;
    return props.isDisabled ? 'cursor: not-allowed;' : css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n            background-color: ", ";\n            box-shadow: inset 0 0 0 ", "px\n              ", ";\n          "])), theme.Colors.PaginationNumberedNavigationBackgroundHovered, function (_ref7) {
      var theme = _ref7.theme;
      return theme.BorderWidth.PaginationNumbered;
    }, theme.Colors.PaginationNumberedNavigationBorderHovered);
  };
}));
PageNav.displayName = 'PageNav';
export var PageNumber = withTheming(styled.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", "px;\n  min-width: ", "px;\n  padding: ", ";\n  cursor: pointer;\n  border: 0;\n  background-color: ", ";\n  box-shadow: inset 0 0 0\n    ", "px\n    ", ";\n  border-radius: ", "px;\n  &:focus {\n    ", ";\n  }\n  &:hover {\n    ", "\n  }\n  &:active {\n    ", "\n  }\n"])), WRAPPER_WIDTH, WRAPPER_WIDTH, CONTENT_PADDING, function (props) {
  return function (_ref8) {
    var theme = _ref8.theme;
    return props.isCurrent ? theme.Colors.PaginationNumberedSelectedBackground : theme.Colors.PaginationNumberedUnselectedBackground;
  };
}, function (props) {
  return function (_ref9) {
    var theme = _ref9.theme;
    return props.isCurrent ? theme.BorderWidth.PaginationNumbered : theme.BorderWidth.PaginationNumberedUnselected;
  };
}, function (props) {
  return function (_ref10) {
    var theme = _ref10.theme;
    return props.isCurrent ? theme.Colors.PaginationNumberedSelectedBorder : theme.Colors.PaginationNumberedUnselectedBorder;
  };
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.Shape.PaginationNumbered === Shape.Circle ? WRAPPER_WIDTH : theme.BorderRadius.ButtonDefault;
}, getFocusStyles(), function (props) {
  return function (_ref12) {
    var theme = _ref12.theme;
    return "\n      background-color: ".concat(props.isCurrent ? theme.Colors.PaginationNumberedSelectedBackgroundHovered : theme.Colors.PaginationNumberedUnselectedBackgroundHovered, ";\n      box-shadow: inset 0 0 0 ").concat(theme.BorderWidth.PaginationNumbered, "px\n        ").concat(props.isCurrent ? theme.Colors.PaginationNumberedSelectedBorderHovered : theme.Colors.PaginationNumberedUnselectedBorderHovered, ";\n    ");
  };
}, function (props) {
  return function (_ref13) {
    var theme = _ref13.theme;
    return "\n      background-color: ".concat(props.isCurrent ? theme.Colors.PaginationNumberedSelectedBackgroundPressed : theme.Colors.PaginationNumberedUnselectedBackgroundPressed, ";\n      box-shadow: inset 0 0 0 ").concat(theme.BorderWidth.PaginationNumbered, "px\n        ").concat(props.isCurrent ? theme.Colors.PaginationNumberedSelectedBorderPressed : theme.Colors.PaginationNumberedUnselectedBorderPressed, ";\n    ");
  };
}));
PageNumber.displayName = 'PageNumber';
export var PageEllipsisWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", ";\n"])), WRAPPER_WIDTH, CONTENT_PADDING);
PageEllipsisWrapper.displayName = 'PageEllipsisWrapper';